import {
  cancelFssToolCall,
  runFssToolCall,
} from "@mirage/mosaics/Chat/components/chat/ConversationMessages/ToolCalls/fss/runners";
import type { ParsedToolCall } from "@mirage/mosaics/Chat/components/chat/ConversationMessages/ToolCalls/types";

/**
 * Run a tool call and return text describing the result of running the tool.
 * This may throw an error if the tool call fails.
 *
 * @param toolCall The tool call to run.
 * @returns The result of running the tool call.
 */
export function runToolCall(toolCall: ParsedToolCall): Promise<string> {
  switch (toolCall.agentId) {
    case "fss_ops":
      return runFssToolCall(toolCall);
    default:
      throw new Error(
        `Attempting to run an unsupported tool call: ${toolCall.agentId}`,
      );
  }
}

/**
 * Get the messages we should send back to the server for cancelling a tool call.
 *
 * @param toolCall The tool call to cancel.
 * @returns The message to send back to the server for cancelling the tool call.
 */
export function cancelToolCall(toolCall: ParsedToolCall): string {
  switch (toolCall.agentId) {
    case "fss_ops":
      return cancelFssToolCall(toolCall);
    default:
      throw new Error(
        `Attempting to get cancel tool call messages for an unsupported tool call: ${toolCall.agentId}`,
      );
  }
}
